import { render, staticRenderFns } from "./CorporateInput.vue?vue&type=template&id=083cc6f2&"
import script from "./CorporateInput.vue?vue&type=script&lang=js&"
export * from "./CorporateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports